import 'slick-carousel';
import {AbstractCarouselComponent} from "./abstract-carousel";
import HideAndShowByFade from "../animations/hide-and-show-by-fade";

export class ProductGalleryComponent extends AbstractCarouselComponent {

    protected $video:JQuery<any>;
    protected $videoContainer:JQuery<any>;

    constructor(elem:HTMLElement) {
        super(elem);
        this.$videoContainer = this.$root.find('.js-product-gallery__video');
        this.$video = this.$videoContainer.find('video');
    }

    getBaseStyleClass() {
        return 'l-product-gallery';
    };

    getBaseJSClass() {
        return 'js-product-gallery';
    };

    protected bindUI = () => {
        this.$root.removeClass(`${this.getBaseStyleClass()}--loading`);
        this.$carousel.on('afterChange', this.handleSlideChange);
        this.$carousel.on('afterChange', this.checkVideo);
        this.$carousel.slick(this.getSlickParams());
        this.$videoContainer.on('click', () => {
            this.$videoContainer.off('click');
            this.$video.get(0).controls = true;
            this.$video
                .off('play')
                .on('play', () => this.$videoContainer.addClass('active'));
            this.$video
                .off('pause')
                .on('pause', () => this.$videoContainer.removeClass('active'));
        })
    }

    checkVideo = (ev:any, slick:JQuerySlick, currentSlide:any) => {
        let $current = slick.$slides.eq(slick.currentSlide);
        if (undefined !== this.$video) {
            if (this.$video.length != 0 && $current.find('video').length == 0) {
                this.$video.get(0).pause();
                this.$video.get(0).currentTime = 0;
            }
        }
    }

    getSlickParams = () => ({
        fade: false,
        dots: false,
        centerMode: false,
        variableWidth: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: false,
        nextArrow: this.$scrollNext,
        prevArrow: this.$scrollPrev,
        appendArrows: this.$controls,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ]
    });
}
